import React from "react";
import mark_profile from "../images/mark_profile.png";
import shea_profile from "../images/shea_profile.jpg";
import brittany from "../images/Brittany.jpg";
import ingrid from "../images/Ingrid.jpg";
import jennifer from "../images/Jennifer.jpg";
import madelyn from "../images/Madelyn.jpg";

const About = () => {
  const contactRise = () => {
    window.location.href = "/contact";
  };
  return (
    <div className="aboutPage">
      <header className="aboutHeader">
        <h1>Meet the Team</h1>
      </header>
      <div className="profilesDiv">
        <section className="profileSection aboutMark">
          <img src={mark_profile} alt="Mark Jagodzinski" />
          <div className="aboutText">
            <h1>Mark Jagodzinski</h1>
            <h3>Owner & Physical Therapist</h3>
            <p>
              Mark is a lifelong resident of the Northwest Phoenix,
              graduating from Brophy College Prep in 1992, before finishing
              his Bachelor of Science in Exercise Physiology at NAU in
              1996. He was honored to be part of the first Doctoral class
              of Physical Therapists, completing his course of study with
              high honors in 2001. He’s spent nearly his entire career
              serving Orthopedic and Sportsmedicine patients across their
              recovery lifespan. Over the years he’s developed a passion
              for treating every patient as an individual and not just a
              diagnosis. He’s earned a reputation for paying close
              attention to the details and valuing the patient experience.
            </p>
            <p>
              Away from the office, you will find him spending time with
              his college sweetheart Mariam. Together, they’re usually
              trying to keep up with the Volleyball exploits of their
              daughters, Madelyn and Morghan. Mark also enjoys music of all
              kinds, and squeezing in a round of golf when able! He looks
              forward to the challenge of having his own practice and being
              able to strike an effective balance between serving the needs
              of his patients and growing the brand of Rise Orthopedic and
              Sports PT.
            </p>
            <div className="socialMediaLinks">
              <a
                href="https://www.facebook.com/mark.jagodzinski"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com/JagskiDPT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/mark-jagodzinski-5b6115b8/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </section>
        <section className="profileSection aboutShea">
          <div className="aboutText aboutTextAlt">
            <h1>Shea Campbell</h1>
            <h3>Physical Therapist</h3>
            <p>
              Shea is originally from Vancouver, British Columbia and grew
              up here in Arizona. He graduated with his Bachelor of Science
              degree in Exercise Science from Northern Arizona University
              in 2012. He then went on to earn his Doctorate of Physical
              Therapy in 2015 from Northern Arizona University as well.
              Shea has since continued to develop his clinical skills in
              functional movement, joint manipulation, and sports-specific
              training.
            </p>
            <p>
              His experience is comprised of orthopedics, post-surgical
              care, neuro rehabilitation, sports injury, and geriatric
              care. Shea follows ice hockey and mixed martial arts
              regularly and when away from the clinic, you will find him
              with his wife Amy and daughters Isla and Evie. We’re very
              excited to have Shea a part of the team here at Rise. He’s
              also a big believer in treating the entire body and is a
              valuable addition to our staff in Surprise, Arizona.
            </p>
            <div className="socialMediaLinks">
              <a
                href="https://www.facebook.com/krazykanuck19"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
          <img src={shea_profile} alt="Shea Campbell" />
        </section>
        <section className="profileSection aboutIngrid">
        <img src={ingrid} alt="Ingrid Miyazato" />
          <div className="aboutText">
            <h1>Ingrid Miyazato</h1>
            <h3>Practice Manager</h3>
            <p>
              Ingrid Miyazato, pictured here with Rise family members Shea
              Campbell and Brittany Moore, is our Practice Manager, our
              behind the scenes glue that holds Rise OSPT together. She
              handles our tech/EMR and billing/collections issues, having
              gained valuable executive level and customer service
              experience during her many years in the airline industry. She
              has long been a patient favorite with her trademark smile and
              reassuring compassion in her voice.
            </p>
            <p>
              When not working from home or helping out in the office, she
              can usually be found with her husband Kory supporting one of
              their five children on a soccer pitch or sport court
              somewhere! She comes from a proudly multi-National background
              and is fluent in four languages including English, Spanish,
              German, and Japanese. We are blessed to have her as part of
              our team and are grateful for her continued selfless devotion
              to helping make Rise what it is today.
            </p>
          </div>
        </section>
        <section className="profileSection aboutJennifer">
          <div className="aboutText aboutTextAlt">
            <h1>Jennifer DelPrincipe</h1>
            <h3>Front Desk</h3>
            <p>
              An Arizona resident since 1988, Jennifer grew up in Tucson
              after her father was stationed at Davis Monthan Air Force
              Base. Jennifer grew up showing Arabian horses prior to
              attending the University of Arizona and earning her Bachelor
              of Arts in Education in 2003.
            </p>
            <p>
              In 2011, Jennifer’s family, husband Kenney, and children
              Bradley and Jillian, moved from Tucson to the West Valley.
              Away from work you can find them cheering at every home game
              for the Arizona Coyotes or cheering Bradley and Jillian on at
              the local ice rink on their youth hockey teams. As a family,
              they also enjoy traveling the State and being outdoors.
            </p>
          </div>
          <img src={jennifer} alt="Jennifer DelPrincipe" />
        </section>
        <section className="profileSection aboutBrittany">
        <img src={brittany} alt="Brittany" />
          <div className="aboutText">
            <h1>Brittany Moore</h1>
            <h3>Physical Therapy Technician</h3>
            <p>
              Brittany is originally from South Carolina and grew up here
              in Surprise, AZ most of her life. Life as an Air Force brat
              allowed her to move around a few times. She graduated with
              her Bachelor of Science in Kinesiology from Arizona State
              University in 2017. Brittany has since been working as a
              Physical Therapy Technician.
            </p>
            <p>
              Away from the clinic, Brittany is spending time with her high
              school sweetheart Zach and daughter Abigail. She enjoys
              following the Pittsburgh Steelers, watching movies daughter,
              and going for leisure hikes with her family. Brittany has
              enjoyed being a part of the Rise family.
            </p>
          </div>
          
        </section>
        <section className="profileSection aboutMadelyn">
          
          <div className="aboutText aboutTextAlt">
            <h1>Madelyn Jagodzinski</h1>
            {/* <h3></h3> */}
            <p>
              Madelyn is an Arizona native. She graduated from Sunrise
              Mountain High School in 2019 and is now a full time student
              at Glendale Community College, pursuing a Bachelors Degree in
              Nursing.
            </p>
            <p>
              When not working at Rise, Madelyn also works the front desk
              of BodyVision Fitness. In her free time she enjoys working
              out, hanging out with her friends and family or playing with
              her puppy. She has loved the opportunity to work for her dad
              and be apart of the Rise Family.
            </p>
          </div>
          <img src={madelyn} alt="Madelyn" />
        </section>
      </div>
      <section className="moreInfo">
        <h2>Request More Information</h2>
        <p className="readyP">
          Are you ready to rise up and feel great again?
        </p>
        <button
          className="requestApptBtn contactRiseBtn"
          onClick={contactRise}
        >
          Contact Rise
        </button>
      </section>
    </div>
  );
};

export default About;
